import React from "react";
import { Link } from "react-router-dom";

const Consultation = () => {
  return (
    <section className="relative py-32 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img
          src="/img/consult-1.avif"
          alt="Boardroom Table"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/70" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white">
        <h2
          data-aos="fade-up"
          className="font-serif text-4xl md:text-6xl font-bold mb-6"
        >
          Claim your free consultation
        </h2>

        <p
          data-aos="fade-up"
          data-aos-delay="100"
          className="text-lg md:text-xl text-gray-300 font-light leading-relaxed mb-10 max-w-2xl mx-auto"
        >
          Take charge of your business future by booking an appointment with our expert consultants. Experience the advantage of tailored solutions that drive rapid growth and efficiency.
        </p>

        <div data-aos="zoom-in" data-aos-delay="200">
          <Link to="/contact" className="btn-primary px-12 py-4 text-base">
            Book now
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Consultation;